module.exports = __webpack_public_path__ + "static/bgmain-e5970dbe3bcc43b71954ca912c20e7ea.png";